import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { Optional } from 'utility-types';

export type AutoraterState = {
  justification?: string;
  likertScore?: number;
};

type ResponseSuggestionsStore = {
  autoraterState: Record<string, AutoraterState>;
  setAutoraterState: (storeKey: string, newState: Optional<AutoraterState>) => void;
  getAutoraterState: (storeKey: string) => AutoraterState | undefined;
};

export const useResponseSuggestionsStore = create<ResponseSuggestionsStore>()(
  devtools((set, get) => ({
    autoraterState: {},
    setAutoraterState: (storeKey: string, newState: Optional<AutoraterState>) => {
      set(state => ({
        autoraterState: {
          ...state.autoraterState,
          [storeKey]: newState,
        },
      }));
    },
    getAutoraterState: (storeKey: string) => {
      const cachedState = get().autoraterState[storeKey];
      if (!cachedState) {
        return undefined;
      }
      return cachedState;
    },
  })),
);
